"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var BarHor_1 = __importDefault(require("atomicComponents/atoms/Graphs/BarHor"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var BarHorTitle_1 = __importDefault(require("atomicComponents/organisms/Text/BarHorTitle"));
var Money_1 = __importDefault(require("components/Money"));
var BarContainer_1 = __importDefault(require("containers/SaaSAudit/Savings/styles/BarContainer"));
var Text_1 = __importDefault(require("shared/components/Text"));
var formatters_1 = require("utils/formatters");
var MissedOpportunities = function (_a) {
    var spend = _a.spend, amount = _a.amount, label = _a.label, service = _a.service, _b = _a.currency, currency = _b === void 0 ? 'AUD' : _b;
    var getPixelScale = function (amt) { return amt / 625; };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center", width: 175 }, { children: [service && (0, jsx_runtime_1.jsx)(Logo_1.default, { brand: service, size: "sm" }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, noWrap: true, ml: 1 }, { children: label || (service === null || service === void 0 ? void 0 : service.niceName) || (service === null || service === void 0 ? void 0 : service.name) }))] })), (0, jsx_runtime_1.jsxs)(BarContainer_1.default, { children: [(0, jsx_runtime_1.jsx)(BarHor_1.default, __assign({ width: getPixelScale(spend), hasWhiteBorder: true, size: "regular" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: spend, isShortened: true }) })), (0, jsx_runtime_1.jsx)(BarHor_1.default, { width: getPixelScale(amount), size: "regular", roundedCornerRight: true, opacity: 0.55 }), (0, jsx_runtime_1.jsx)(BarHorTitle_1.default, { value: (0, formatters_1.formatMoney)(amount, currency, true) })] })] })));
};
exports.default = MissedOpportunities;
